import {Signals} from "@/Imports"
import Facade from "@/Facade"

export default class PromoBackend {

    constructor() {
        Signals.promo.add(this.onPromo, this)
    }

    onPromo = async (content) => {
        const response = await fetch(content.data.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'session_token': Facade.model.sessionToken,
            })
        })
        const json = await response.json()
        if(json.result) {
            Facade.model.freebets = json.freebet
        }

        Signals.errorMessage.dispatch({msg: json.message, type: 'promo'})
    }
}